var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoUpdate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.424,
    height: 15.802,
    viewBox: "0 0 16.424 15.802",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "progress-arrows",
    transform: "translate(0 -.464)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47665",
    "data-name": "Path 47665",
    d: "M3.536,19.149a.283.283,0,0,1-.2-.08L.081,15.8a.277.277,0,0,1,0-.391l3.256-3.269a.279.279,0,0,1,.3-.06.274.274,0,0,1,.171.257v2.021h8.922a.449.449,0,0,0,.448-.447V11.641a.284.284,0,0,1,.08-.2l2.179-2.187a.279.279,0,0,1,.476.2V14.4a2.413,2.413,0,0,1-2.7,2.7H3.813v1.774a.273.273,0,0,1-.171.254A.282.282,0,0,1,3.536,19.149Z",
    transform: "translate(0 -2.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47666",
    "data-name": "Path 47666",
    d: "M1.033,10.443a.282.282,0,0,1-.279-.278V5.22a2.411,2.411,0,0,1,2.7-2.7h9.41V.742a.284.284,0,0,1,.171-.258.279.279,0,0,1,.3.062l3.254,3.262a.279.279,0,0,1,0,.393L13.338,7.468a.273.273,0,0,1-.3.061.278.278,0,0,1-.171-.258V5.254H3.935a.446.446,0,0,0-.444.448V7.977a.28.28,0,0,1-.083.2L1.228,10.36A.269.269,0,0,1,1.033,10.443Z",
    transform: "translate(-.249)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoUpdate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_update.8452d440adc33e8da7cdf7c24ab0ff68.svg";